import { render } from "./MainHeader.vue?vue&type=template&id=0ed6053c&ts=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/MainHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ed6053c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ed6053c', __exports__)) {
    api.reload('0ed6053c', __exports__)
  }
  
  module.hot.accept("./MainHeader.vue?vue&type=template&id=0ed6053c&ts=true", () => {
    api.rerender('0ed6053c', render)
  })

}


export default __exports__